import {
  CollectionStatsViewedAction,
  CollectionTabSelectedAction,
  CreatorCollectionDownloadAction,
  UserAction
} from 'modules/tracking/types/user-actions';

export const isCreatorCollectionDownloadAction = (
  action?: UserAction
): action is CreatorCollectionDownloadAction => (
  action !== undefined
  && action.eventCategory === 'collections'
  && action.eventAction === 'creators-downloaded'
);

export const isCollectionTabSelectedAction = (
  action?: UserAction
): action is CollectionTabSelectedAction => (
  action !== undefined
  && action.eventCategory === 'collections'
  && action.eventAction === 'tab-selected'
);

export const isCollectionStatsViewedAction = (
  action?: UserAction
): action is CollectionStatsViewedAction => (
  action !== undefined
  && action.eventCategory === 'collections'
  && action.eventAction === 'stats-viewed'
);
